export default "__VITE_ASSET__53bf4733__"